export default {
  getLots: state => state.lots
}
